import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ExternalLinkComponent } from '@web/shared/ui';

@Component({
  selector: 'app-footer-link',
  imports: [ExternalLinkComponent],
  templateUrl: './footer-link.component.html',
  styleUrl: './footer-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterLinkComponent {
  public readonly link = input.required<string>();
  public readonly text = input.required<string>();
}
